import React from "react";
import { Database, FileText, Wrench } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ToolsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-6xl space-y-6 py-6">
      <div>
        <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold uppercase tracking-wide text-slate-500">
          <Wrench className="h-3.5 w-3.5" />
          Outils Deepflow
        </div>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-slate-950">Outils</h1>
      </div>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        <button
          type="button"
          onClick={() => navigate("/tools/guttenberg")}
          className="rounded-xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:border-blue-200 hover:shadow"
        >
          <div className="flex items-center gap-3">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-blue-50 text-blue-700">
              <FileText className="h-5 w-5" />
            </span>
            <div>
              <h2 className="text-lg font-semibold text-slate-950">Guttenberg</h2>
              <p className="text-sm text-slate-500">Generation de rapports techniques.</p>
            </div>
          </div>
        </button>
        <button
          type="button"
          onClick={() => navigate("/tools/knowledge")}
          className="rounded-xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:border-blue-200 hover:shadow"
        >
          <div className="flex items-center gap-3">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-emerald-50 text-emerald-700">
              <Database className="h-5 w-5" />
            </span>
            <div>
              <h2 className="text-lg font-semibold text-slate-950">Knowledge / RAG</h2>
              <p className="text-sm text-slate-500">Recherche et vectorisation par projet.</p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default ToolsPage;
